import { useSession } from '@/stores/session';

/** 客户 / 供应商两段（NAV「客户 / 供应商」一个入口）；淘宝店管理员也能看客户（老接口 customers.read 或 taobao.manage） */
export function usePartnerSegments() {
  const can = useSession((st) => st.can);
  const items: { to: string; label: string }[] = [];
  if (can('customers.read', 'taobao.manage')) items.push({ to: '/customers', label: '客户' });
  if (can('suppliers.read')) items.push({ to: '/suppliers', label: '供应商' });
  return items;
}
